export interface PsaProjectEmission {
  id:number
  projectId: number;
  projectName?: string,
  emissionNumber: string;
  emissionQuantity: number;
  startDate: string;
  endDate: string;
  harvests: PsaHarvest[];
  rmLink: string;
  details: string;
  project: PsaProject;
  serialCode: string;
  status:string;
  insertDate:string;
  reasonRejection?:string
  showReason?:boolean
  totalCount?: number;
  cpfCnpjCode?:string,
  holderCode?:string
}

export interface PsaProjectEmissionMeta {
  totalPages?: number;
  totalRecords?: number;
}

export interface PsaProject{
  id: number;
  name: string
}

export interface PsaHarvest {
  id?:number;
  harvestYear: number;
  quantity: number;
  developerName?:string;
  developerId?: number;
  developer?: PsaDeveloper;
}

export interface PsaDeveloper{
  id:number;
  name:string;
}

export interface PsaEmissionConsultFilter {
  projectName?: string | null;
  serialCode?: string | null;
  status?: string | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface PsaEmissionConsultResponse {
  data?: PsaItemsEmissionConsultData;
  meta?: PsaProjectEmissionMeta
}

export interface PsaEmissionUpdateStatus{
  status:string,
  description?:string
}

interface PsaItemsEmissionConsultData {
  carbonEmissions?: PsaProjectEmission[];
  carbonCredits?: PsaProjectEmission[];
}

export enum EmissionStatus {
  PENDING_AUDITOR_VERIFICATION = 'PENDENTE DE VALIDAÇÃO DO AUDITOR',
  APPROVED_BY_AUDITOR = 'APROVADO PELO AUDITOR',
  REJECTED_BY_AUDITOR = 'REJEITADO PELO AUDITOR',
  ADJUSTED_BY_DEVELOPER = 'AJUSTADO PELO DESENVOLVEDOR',
  PENDING_DEVELOPER_CONFIRMATION = 'PENDENTE DE CONFIRMACAO DO DESENVOLVEDOR',
  CONFIRMED_BY_DEVELOPER = 'CONFIRMADO PELO DESENVOLVEDOR',
  REJECTED_BY_DEVELOPER = 'REJEITADO PELO DESENVOLVEDOR',
  REGISTERED_IN_B3 = 'REGISTRADO NA B3'
}

export enum EmissionStatusCode {
  PENDING_AUDITOR_VERIFICATION = 'PENDING_AUDITOR_VERIFICATION',
  APPROVED_BY_AUDITOR = 'APPROVED_BY_AUDITOR',
  REJECTED_BY_AUDITOR = 'REJECTED_BY_AUDITOR',
  ADJUSTED_BY_DEVELOPER = 'ADJUSTED_BY_DEVELOPER',
  PENDING_DEVELOPER_CONFIRMATION = 'PENDING_DEVELOPER_CONFIRMATION',
  CONFIRMED_BY_DEVELOPER = 'CONFIRMED_BY_DEVELOPER',
  REJECTED_BY_DEVELOPER = 'REJECTED_BY_DEVELOPER',
  REGISTERED_IN_B3 = 'REGISTERED_IN_B3'
}

export enum EmissionStatusFilter {
  ALL = 'Todos',
  PENDING_AUDITOR_VERIFICATION = 'Pendente de verificação do auditor',
  REJECTED_BY_AUDITOR = 'Rejeitado pelo auditor',
  PENDING_DEVELOPER_CONFIRMATION = 'Pendente de confirmação do desenvolvedor',
  REGISTERED_IN_B3 = 'Registrado na B3'
}

export type BadgeEmissionStatus = 
| 'PENDENTE DE VALIDAÇÃO DO AUDITOR'
| 'APROVADO PELO AUDITOR'
| 'REJEITADO PELO AUDITOR'
| 'AJUSTADO PELO DESENVOLVEDOR'
| 'PENDENTE DE CONFIRMACAO DO DESENVOLVEDOR'
| 'CONFIRMADO PELO DESENVOLVEDOR'
| 'REJEITADO PELO DESENVOLVEDOR'
| 'REGISTRADO NA B3';
